export enum ATTACHMENT_PARENT_TYPE {
  INVOICE = "INVOICE",
  CONTACT = "CONTACT",
  COMPANY_LOGO = "COMPANY_LOGO",
  PAYMENT = "PAYMENT",
  PAYMENT_EMAIL = "PAYMENT_EMAIL",
  PAYMENT_LINK = "PAYMENT_LINK",
}
